// Buy now, Add to Bag and Make an offer stay enabled for everyone (BSC-82). This decides what a
// click does: a signed-out visitor sees the sign-in prompt once per browser session and goes
// straight to sign-in after that; a signed-in user must have verified their email first.

export const SIGN_IN_PROMPT_SEEN_KEY = 'bsSignInPromptSeen';

export const LISTING_ACTION_ALLOW = 'allow';
export const LISTING_ACTION_SIGN_IN_PROMPT = 'signInPrompt';
export const LISTING_ACTION_LOGIN = 'login';
export const LISTING_ACTION_VERIFY_EMAIL = 'verifyEmail';
// Signed in, but the user record has not loaded yet.
export const LISTING_ACTION_WAIT = 'wait';

// sessionStorage can be missing (server render) or throw (blocked site data).
const browserSessionStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};

export const hasSeenSignInPrompt = (storage = browserSessionStorage()) => {
  try {
    return !!storage && storage.getItem(SIGN_IN_PROMPT_SEEN_KEY) === 'true';
  } catch (e) {
    return false;
  }
};

export const markSignInPromptSeen = (storage = browserSessionStorage()) => {
  try {
    if (storage) {
      storage.setItem(SIGN_IN_PROMPT_SEEN_KEY, 'true');
    }
  } catch (e) {
    // Without storage the prompt shows on every first click, which is still usable.
  }
};

export const listingActionStep = (isAuthenticated, currentUser, storage) => {
  if (!isAuthenticated) {
    return hasSeenSignInPrompt(storage) ? LISTING_ACTION_LOGIN : LISTING_ACTION_SIGN_IN_PROMPT;
  }
  if (!currentUser?.id) {
    return LISTING_ACTION_WAIT;
  }
  return currentUser.attributes?.emailVerified ? LISTING_ACTION_ALLOW : LISTING_ACTION_VERIFY_EMAIL;
};
